import { types } from 'mime-types'
import { CSSProperties, FC, useMemo } from 'react'
import AudioIcon from '../../assets/icons/AudioIcon.svg?react'
import DocumentIcon from '../../assets/icons/DocumentIcon.svg?react'
import FilmIcon from '../../assets/icons/Film.svg?react'
import ImageIcon from '../../assets/icons/ImageIcon.svg?react'

type Props = {
    type?: string
    style?: CSSProperties
}

export const FileIcon: FC<Props> = ({ type, style }) => {
    const Icon = useMemo(() => {
        if (type) {
            const memoType = `${types[type]}`
            const memoTypeVideoExtended = `${types[`${type}v`]}`

            if (memoType.includes('image')) {
                return ImageIcon
            }

            if (memoType.includes('audio')) {
                return AudioIcon
            }

            if (memoType.includes('video') || memoTypeVideoExtended.includes('video')) {
                return FilmIcon
            }
        }

        return DocumentIcon
    }, [type])

    return <Icon style={style} />
}
